import { Flex, TextField, Text, DialogRoot } from "@radix-ui/themes";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { DialogContent } from "../../ui/Dialog";
import { useAppStore } from "../../stores/RootStore";
import { Label } from "../../ui/Label/Label";
import { Input } from "../../ui/Input/Input";
import OneSelector from "../../ui/OneSelector/OneSelector";
import { Button } from "../../ui/Button";
import { useFetch } from "../../hooks/useFetch";
import { Device } from "../../types/types";
import { DatePicker } from "../../ui/Datepicker/DatePicker";
import { DateTime } from "luxon";
import Spinner from "@/ui/Spinner/Spinner";

type Props = {
  isExportOpen: boolean;
  closeModal: Function;
  currentItem: Device;
  setCsvData: Function;
};

const ExportForm = ({
  isExportOpen,
  closeModal,
  currentItem,
  setCsvData,
}: Props) => {
  const sensors = _.flatten(
    currentItem.attributes.slots?.map((slot) => slot.sensors),
  );
  const sensorsList = sensors.map((sensor) => {
    return { value: String(sensor.id), label: sensor.sensor_type.name };
  });

  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      date: DateTime.local().toJSDate(),
      sensor_type: { value: "", label: "" },
      sensorId: "",
    },
  });

  const [sensorId, setSensorId] = useState("5009");
  const [params, setParams] = useState(new URLSearchParams({}));

  if (isExportOpen) console.log(sensors);

  const openStateChange = () => {
    if (isExportOpen) closeModal();
  };

  const [
    {
      response: itemUpdateResponse,
      isLoading: itemUpdateIsLoading,
      error: itemUpdateError,
    },
    doFetchItem,
  ] = useFetch(
    `/devices/sensors/${sensorId}/received_data?${params}&capacity=raw`,
  );

  const onSubmit = (formData: any) => {
    let newUsageParams = new URLSearchParams({});
    newUsageParams.append(
      "from",
      DateTime.fromJSDate(formData.date).startOf("day").setZone("utc").toISO()!,
    );
    newUsageParams.append(
      "to",
      DateTime.fromJSDate(formData.date).endOf("day").setZone("utc").toISO()!,
    );
    setSensorId(formData.sensor_type.value);
    setParams(newUsageParams);
    doFetchItem();
    reset();
  };

  useEffect(() => {
    if (!itemUpdateResponse) return;
    if (itemUpdateResponse) {
      openStateChange();
    }
    const data = itemUpdateResponse?.data.attributes.data.map(
      (item: { v: number; at: number }) =>
        item.v ? [item.at, item.v] : [item.at, 0],
    );
    setCsvData(data);
  }, [itemUpdateResponse]);

  return (
    <DialogRoot open={isExportOpen} onOpenChange={openStateChange}>
      <DialogContent style={{ maxWidth: 600, position: "fixed", top: "30%" }}>
        <div className="text-lg font-medium">{t("exporting_data")}</div>
        <div className="text-sm">{t("exporting_sensor_data_text")}</div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="w-full items-end gap-4 mt-4">
            {itemUpdateIsLoading ? <Spinner /> : <div className="grid grid-cols-1 items-end w-full gap-4">
              <Controller
                name="sensor_type"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <div className="relative flex flex-col space-y-2">
                    <Label>{t("sensor_type")}*</Label>
                    <OneSelector
                      placeholder={"Выберите сенсор"}
                      value={
                        value
                          ? sensorsList.find(
                              (s) => s.value == String(value.value),
                            )!
                          : undefined
                      }
                      onChange={onChange}
                      defaultOptions={sensorsList}
                    />
                  </div>
                )}
              />
              <Controller
                name="date"
                control={control}
                render={({ field: { value, onChange } }) => (
                  <div className="relative space-y-2">
                    <Label>{t("date")}</Label>
                    <DatePicker
                      mode="single"
                      selected={value}
                      onSelect={onChange}
                      disabled={{
                        after: DateTime.local().toJSDate(),
                      }}
                    />
                  </div>
                )}
              />
            </div>}
            <div className="flex justify-end mt-4">
              <Button variant={"default"} size={"sm"}>
                {t("export")}
              </Button>
            </div>
          </div>
        </form>
      </DialogContent>
    </DialogRoot>
  );
};

export default ExportForm;
